import { render, staticRenderFns } from "./ActivationComponent.vue?vue&type=template&id=03a6980c&scoped=true"
import script from "./ActivationComponent.vue?vue&type=script&lang=js"
export * from "./ActivationComponent.vue?vue&type=script&lang=js"
import style0 from "./ActivationComponent.vue?vue&type=style&index=0&id=03a6980c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a6980c",
  null
  
)

export default component.exports